import EmailValidator from 'email-validator';

const compositionValidators = {
  email: input => EmailValidator.validate(input),
  name: input => input.length < 24,
  message: () => true,
};

export default compositionValidators;
